let promise;
export const queueMicrotask = typeof window !== 'undefined' && typeof window.queueMicrotask === 'function'
    ? window.queueMicrotask.bind(typeof window !== 'undefined' ? window : global)
    : // reuse resolved promise, and allocate it lazily
        (cb) => (promise || (promise = Promise.resolve())).then(cb).catch((err) => setTimeout(() => {
            throw err;
        }, 0));
//# sourceMappingURL=queueMicrotask.js.map